var identity = require('./identity');

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;



//////////////////
// WEBPACK FOOTER
// ./~/victory-create-container/~/lodash/_castFunction.js
// module id = ./node_modules/victory-create-container/node_modules/lodash/_castFunction.js
// module chunks = 1